/* GP STORE — Glow Lab interactions for home, collection, product and contact sections (store-design team) */
(function () {
  function tapToGlow(media) {
    media.addEventListener('click', function (e) {
      if (e.target.closest('a,button,form')) return;
      media.classList.toggle('on');
      var tap = media.querySelector('.gl-tap');
      if (tap) tap.textContent = media.classList.contains('on') ? '● GLOWING' : '✦ TAP TO GLOW';
    });
  }

  function cards(root) {
    root.querySelectorAll('.gl-card').forEach(function (el) {
      var inner = el.querySelector('.gl-inner');
      tapToGlow(el.querySelector('.gl-media'));
      el.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect();
        inner.style.transform = 'rotateY(' + ((e.clientX - r.left) / r.width - .5) * 12 + 'deg) rotateX(' + -((e.clientY - r.top) / r.height - .5) * 12 + 'deg)';
      });
      el.addEventListener('pointerleave', function () { inner.style.transform = ''; });
    });
  }

  function reveal(root) {
    var els = root.querySelectorAll('.gl-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: .05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Glow Lab demo: companions come from .gl-labitem (each with its real number of brightness levels) */
  function lab(root) {
    var box = root.querySelector('.gl-lab'); if (!box) return;
    var lamp = box.querySelector('.gl-lamp'), img = lamp.querySelector('img'), chips = box.querySelector('.gl-chips'), power = box.querySelector('.gl-power');
    var btns = [].slice.call(box.querySelectorAll('.gl-lvl')), note = box.querySelector('.gl-levelnote'), name = box.querySelector('.gl-lampname');
    var set = [].slice.call(box.querySelectorAll('.gl-labitem')), on = false, pick = 0, level = 3;
    if (!set.length) return;
    function max(d) { return Math.max(1, Math.min(3, +d.dataset.levels || 1)); }
    function render() {
      var d = set[pick], m = max(d);
      if (level > m) level = m;
      img.src = d.dataset.img; img.alt = d.dataset.name;
      name.textContent = d.dataset.name; name.href = d.dataset.url;
      box.querySelector('.gl-lampid').textContent = (m > 1 ? m + ' GLOW LEVELS' : 'ON / OFF') + ' · ' + d.dataset.price;
      btns.forEach(function (b) { var l = +b.dataset.l; b.disabled = l > m; b.classList.toggle('active', l === level); });
      if (note) note.textContent = m > 1 ? 'This companion dims in ' + m + ' levels.' : 'This companion switches on and off.';
      var f = level / m;
      lamp.style.setProperty('--g', on ? .3 + .6 * f : 0);
      lamp.style.setProperty('--b', on ? 1 + .25 * f : .85);
      lamp.style.setProperty('--s', on ? 1.15 : .9);
      box.classList.toggle('night', on);
      power.textContent = on ? '⏻ Glowing — tap to switch off' : '⏻ Lights out — switch it on';
    }
    set.forEach(function (d, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gl-chip' + (i === 0 ? ' active' : '');
      b.textContent = d.dataset.name.replace(/ Night (Light|Lamp).*$/, '');
      b.onclick = function () { pick = i; level = max(d); chips.querySelectorAll('.gl-chip').forEach(function (c) { c.classList.remove('active'); }); b.classList.add('active'); render(); };
      chips.appendChild(b);
    });
    btns.forEach(function (b) {
      b.onclick = function () { if (b.disabled) return; level = +b.dataset.l; on = true; render(); };
    });
    power.onclick = lamp.onclick = function () { on = !on; render(); };
    level = max(set[0]); render();
  }

  function countdown(root) {
    var el = root.querySelector('.gl-count'); if (!el) return;
    var target = new Date(el.dataset.target).getTime();
    function tick() {
      var s = Math.max(0, Math.floor((target - Date.now()) / 1000));
      var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
      el.querySelectorAll('b').forEach(function (b, i) { b.textContent = isNaN(v[i]) ? '--' : String(v[i]).padStart(2, '0'); });
    }
    tick(); setInterval(tick, 1000);
  }

  function product(root) {
    var pdp = root.querySelector('.gl-pdp'); if (!pdp) return;
    var main = pdp.querySelector('.gl-gallery .gl-media'), mainImg = main.querySelector('img');
    tapToGlow(main);
    function show(src) { if (src && mainImg) { mainImg.src = src; mainImg.removeAttribute('srcset'); } }
    pdp.querySelectorAll('.gl-thumbs button').forEach(function (b) {
      b.onclick = function () { pdp.querySelectorAll('.gl-thumbs button').forEach(function (x) { x.classList.remove('active'); }); b.classList.add('active'); show(b.dataset.src); };
    });
    var price = pdp.querySelector('.gl-bigprice'), add = pdp.querySelector('.gl-addbtn');
    pdp.querySelectorAll('.gl-opt input').forEach(function (r) {
      r.addEventListener('change', function () {
        price.innerHTML = r.dataset.price + (r.dataset.compare ? '<s>' + r.dataset.compare + '</s>' : '');
        show(r.dataset.img);
        add.disabled = r.dataset.available !== 'true';
        add.textContent = add.disabled ? 'Sold out' : 'Add to cart';
        var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u);
      });
    });
    var qty = pdp.querySelector('.gl-qty input');
    pdp.querySelectorAll('.gl-qty button').forEach(function (b) {
      b.onclick = function () { qty.value = Math.max(1, (+qty.value || 1) + (+b.dataset.d)); };
    });
  }

  function sparkles(stage) {
    var NS = 'http://www.w3.org/2000/svg';
    [[12, 18, 0], [84, 14, .8], [8, 74, 1.6], [90, 62, 2.2], [70, 88, 1.1]].forEach(function (s) {
      var el = document.createElementNS(NS, 'svg'), p = document.createElementNS(NS, 'path');
      el.setAttribute('viewBox', '0 0 34 34'); el.setAttribute('class', 'gl-spark');
      el.style.left = s[0] + '%'; el.style.top = s[1] + '%'; el.style.animationDelay = s[2] + 's';
      p.setAttribute('d', 'M17 0 L20.5 13.5 L34 17 L20.5 20.5 L17 34 L13.5 20.5 L0 17 L13.5 13.5Z');
      p.setAttribute('fill', '#fff'); p.setAttribute('stroke', '#8FB4FF');
      el.appendChild(p); stage.appendChild(el);
    });
  }

  function hero3D(stage) {
    var canvas = stage.querySelector('canvas');
    if (!window.THREE || !canvas || canvas.dataset.on) return;
    canvas.dataset.on = '1';
    var renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true }); } catch (e) { return; }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches, mobile = window.innerWidth < 760;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, mobile ? 1.5 : 2));
    renderer.outputEncoding = THREE.sRGBEncoding;
    var scene = new THREE.Scene(); scene.fog = new THREE.Fog(0xDCEBFF, 11, 26);
    var camera = new THREE.PerspectiveCamera(38, 1, .1, 100); camera.position.set(0, .4, 8.4);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x6f95ff, .5));
    var key = new THREE.DirectionalLight(0xffffff, .95); key.position.set(-4, 6, 6); scene.add(key);
    var rim = new THREE.PointLight(0x8fd3ff, 1.4, 20); rim.position.set(4, -1, 3); scene.add(rim);
    var warm = new THREE.PointLight(0xffc774, 0, 8); warm.position.set(0, 0, 2.4); scene.add(warm);
    var world = new THREE.Group(); scene.add(world);
    var core = new THREE.Group(); world.add(core);
    var sphereMat = new THREE.MeshPhysicalMaterial({ color: 0x1f5cf0, roughness: .18, metalness: .1, clearcoat: 1, clearcoatRoughness: .08 });
    core.add(new THREE.Mesh(new THREE.SphereGeometry(1.2, mobile ? 48 : 96, mobile ? 32 : 64), sphereMat));
    var c = document.createElement('canvas'); c.width = c.height = 512;
    var g = c.getContext('2d'), grd = g.createRadialGradient(256, 256, 40, 256, 256, 250);
    grd.addColorStop(0, '#6fb8ff'); grd.addColorStop(.6, '#2f6bff'); grd.addColorStop(.92, '#173f9e'); grd.addColorStop(1, 'rgba(23,63,158,0)');
    g.fillStyle = grd; g.beginPath(); g.arc(256, 256, 250, 0, Math.PI * 2); g.fill();
    g.strokeStyle = 'rgba(255,255,255,.18)'; g.lineWidth = 3;
    for (var a = 0; a < 48; a++) { var t = a / 48 * Math.PI * 2; g.beginPath(); g.moveTo(256 + Math.cos(t) * 70, 256 + Math.sin(t) * 70); g.lineTo(256 + Math.cos(t) * 200, 256 + Math.sin(t) * 200); g.stroke(); }
    g.fillStyle = '#081a44'; g.beginPath(); g.ellipse(256, 256, 34, 118, 0, 0, Math.PI * 2); g.fill();
    g.fillStyle = '#fff'; g.beginPath(); g.arc(214, 186, 20, 0, Math.PI * 2); g.fill();
    var tex = new THREE.CanvasTexture(c); tex.encoding = THREE.sRGBEncoding;
    var iris = new THREE.Mesh(new THREE.CircleGeometry(.52, 64), new THREE.MeshBasicMaterial({ map: tex, transparent: true }));
    iris.position.z = 1.21; core.add(iris);
    var lens = new THREE.Mesh(new THREE.SphereGeometry(.56, 48, 24, 0, Math.PI * 2, 0, Math.PI / 3.2), new THREE.MeshPhysicalMaterial({ color: 0xffffff, transparent: true, opacity: .1, roughness: 0, clearcoat: 1, depthWrite: false }));
    lens.rotation.x = Math.PI / 2; lens.position.z = .78; core.add(lens);
    var ringMat = new THREE.MeshStandardMaterial({ color: 0xa9c6ff, metalness: .55, roughness: .22, emissive: 0x2f6bff, emissiveIntensity: .12 });
    var orbMat = new THREE.MeshPhysicalMaterial({ color: 0x4f86ff, roughness: .15, clearcoat: 1 });
    /* orbit rings: each ring's plane precesses around the core (visible gyroscope motion) while its bead travels along it */
    var rings = [];
    [[1.25, 0, 0, 2.15, .55, .22], [1.1, .95, .2, 2.0, -.4, -.17], [1.15, -.95, -.2, 2.3, .3, .13]].forEach(function (r, i) {
      var turn = new THREE.Group(), tilt = new THREE.Group(); tilt.rotation.set(r[0], r[1], r[2]); turn.add(tilt);
      var spin = new THREE.Group(); tilt.add(spin);
      spin.add(new THREE.Mesh(new THREE.TorusGeometry(r[3], .05, 16, 200), ringMat));
      var orb = new THREE.Mesh(new THREE.SphereGeometry(i === 0 ? .17 : .11, 32, 16), orbMat); orb.position.set(r[3], 0, 0); spin.add(orb);
      world.add(turn); rings.push({ turn: turn, base: r[1], spin: spin, speed: r[4], precess: r[5], wobble: tilt, tiltBase: r[0] });
    });
    var hexPts = [];
    for (var k = 0; k <= 6; k++) { var an = k / 6 * Math.PI * 2 + Math.PI / 6; hexPts.push(new THREE.Vector3(Math.cos(an) * 1.95, Math.sin(an) * 1.95, -.6)); }
    var hex = new THREE.Line(new THREE.BufferGeometry().setFromPoints(hexPts), new THREE.LineBasicMaterial({ color: 0x5b8cff, transparent: true, opacity: .55 }));
    world.add(hex);
    /* satellites: slow elliptical orbits that stay inside the frame (radius, height, phase, angular speed, size) */
    var sats = [];
    [[2.35, 1.3, 2.4, .16, .2], [2.15, -1.15, .2, -.12, .24], [2.5, .3, 4.2, .1, .12]].forEach(function (s) {
      var m = new THREE.Mesh(new THREE.SphereGeometry(s[4], 32, 16), orbMat); m.userData = { r: s[0], y: s[1], p: s[2], w: s[3] }; scene.add(m); sats.push(m);
    });
    var gridH = new THREE.GridHelper(40, 40, 0x7fa8ff, 0xb3cdff); gridH.position.y = -2.4; scene.add(gridH);
    var sc = document.createElement('canvas'); sc.width = sc.height = 128;
    var sg = sc.getContext('2d'), sgr = sg.createRadialGradient(64, 64, 0, 64, 64, 64);
    sgr.addColorStop(0, 'rgba(26,71,201,.35)'); sgr.addColorStop(1, 'rgba(26,71,201,0)'); sg.fillStyle = sgr; sg.fillRect(0, 0, 128, 128);
    var shadow = new THREE.Mesh(new THREE.PlaneGeometry(4, 4), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(sc), transparent: true, depthWrite: false }));
    shadow.rotation.x = -Math.PI / 2; shadow.position.y = -2.38; scene.add(shadow);
    var pg = new THREE.BufferGeometry(), pc = mobile ? 120 : 260, pos = new Float32Array(pc * 3);
    for (var q = 0; q < pc; q++) { pos[q * 3] = (Math.random() - .5) * 12; pos[q * 3 + 1] = (Math.random() - .3) * 7; pos[q * 3 + 2] = (Math.random() - .5) * 6; }
    pg.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    var dust = new THREE.Points(pg, new THREE.PointsMaterial({ color: 0x5b8cff, size: .035, transparent: true, opacity: .7 })); scene.add(dust);
    var clock = new THREE.Clock(), mx = 0, my = 0, pulse = 0, lastMove = -10, blinkAt = 3, blinkT = -1;
    window.addEventListener('pointermove', function (e) { mx = e.clientX / window.innerWidth * 2 - 1; my = e.clientY / window.innerHeight * 2 - 1; lastMove = clock.getElapsedTime(); });
    canvas.addEventListener('click', function () { pulse = 1; });
    function resize() { var w = canvas.clientWidth, h = canvas.clientHeight; if (!w || !h) return; renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); camera.position.z = w / h < .8 ? 10.5 : 8.4; }
    window.addEventListener('resize', resize); resize();
    var visible = true; new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(canvas);
    /* "reduce motion" visitors still get a calm, slower scene instead of a frozen one */
    var sp = reduce ? .5 : 1;
    (function frame() {
      requestAnimationFrame(frame);
      if (!visible) return;
      var t = clock.getElapsedTime();
      world.position.y = Math.sin(t * 1.2) * .12 * sp; shadow.scale.setScalar(1 - Math.sin(t * 1.2) * .06 * sp);
      rings.forEach(function (r) {
        r.spin.rotation.z += r.speed * .012 * sp;
        r.turn.rotation.z = t * r.precess * sp;
        r.wobble.rotation.x = r.tiltBase + Math.sin(t * .4 + r.base) * .12 * sp;
      });
      hex.rotation.z = t * .08 * sp;
      /* eye: follow the pointer; after 2.5s idle (or on touch screens) it looks around on its own */
      var tx = mx * .55, ty = my * .35;
      if (t - lastMove > 2.5) { tx = Math.sin(t * .45 * sp) * .5; ty = Math.sin(t * .31 * sp + 1) * .25; }
      core.rotation.y += (tx - core.rotation.y) * .06; core.rotation.x += (ty - core.rotation.x) * .06;
      /* blink every 3-6 seconds */
      if (blinkT < 0 && t > blinkAt) blinkT = t;
      if (blinkT >= 0) { var k = (t - blinkT) / .22; iris.scale.y = k < 1 ? 1 - .92 * Math.sin(k * Math.PI) : 1; if (k >= 1) { blinkT = -1; blinkAt = t + 3 + Math.random() * 3; } }
      sats.forEach(function (m) { var d = m.userData, a = d.p + t * d.w * sp; m.position.set(Math.cos(a) * d.r, d.y + Math.sin(a * 2) * .2, Math.sin(a) * d.r * .55 - .2); });
      dust.rotation.y = t * .02 * sp; pulse *= .96; warm.intensity = pulse * 3; sphereMat.emissive.setRGB(pulse * .9, pulse * .6, pulse * .2);
      renderer.render(scene, camera);
    })();
  }

  function init(root) {
    cards(root); reveal(root); lab(root); countdown(root); product(root);
    var stage = root.querySelector('.gl-stage');
    if (stage) {
      sparkles(stage);
      if (window.THREE) hero3D(stage); else window.addEventListener('load', function () { hero3D(stage); });
    }
  }
  function boot() { document.querySelectorAll('.glx').forEach(function (r) { if (!r.dataset.ready) { r.dataset.ready = '1'; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
